{
  "version": "v4.3.0",
  "name": "TestToken",
  "bytecode": "040409121b4025010000000102ce0002010000000102ce0102010000000102ce02020100000001040c0d3602",
  "codeHash": "32d99ee24650d37c7111a9cc02ed2694b608e2d1b52301d27c6b28abc9ba94e9",
  "fieldsSig": {
    "names": [
      "symbol",
      "name",
      "decimals",
      "__stdInterfaceId"
    ],
    "types": [
      "ByteVec",
      "ByteVec",
      "U256",
      "ByteVec"
    ],
    "isMutable": [
      false,
      false,
      false,
      false
    ]
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "getSymbol",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "getName",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "getDecimals",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "getTotalSupply",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "U256"
      ]
    }
  ],
  "constants": [],
  "enums": [],
  "stdInterfaceId": "0001"
}